import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'common/utils/withRouter'
import _ from 'lodash'
import Well from '../common/Well'
import Account from '../retailer/form/Account'
import Subscription from '../retailer/form/Subscription'
import ProfileUrl from '../retailer/form/ProfileUrl'
import ContactInfo from '../retailer/form/ContactInfo'
import StoreInfo from '../retailer/form/StoreInfo'
import StoreRep from '../retailer/form/StoreRep'
import StoreServices from '../retailer/form/StoreServices'
import StoreHours from '../retailer/form/StoreHours'
import StoreLinks from '../retailer/form/StoreLinks'
import StoreGallery from '../retailer/form/StoreGallery'
import StoreMasthead from '../retailer/form/StoreMasthead'
import StorePolicies from '../retailer/form/StorePolicies'
import {
  getRetailer,
  createRetailer,
  saveRetailer,
  deleteRetailer,
  deleteRetailerImage,
  deleteRetailerImages,
  deleteRetailerRepImage as deleteRetailerRepImageAction,
  deleteRetailerMastheadImage as deleteRetailerMastheadImageAction,
  checkRetailerCustomUrl,
  resetCheckRetailerCustomUrl
} from '../../actions/retailer'
import { showFullscreenLoader, hideFullscreenLoader } from '../../actions/form'
import {
  handleFieldChange,
  withGallery,
  FormErrorMessage
} from '../../utils/form'
import {
  statusCodes,
  marshalStoreHours,
  unmarshalStoreHours,
  isStandardRetailer
} from '../../utils/retailer'
import { SERVER } from '../../constants'
import { withSavedFlag } from '../../utils/savedMessage'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './Form.module.css'

class RetailerForm extends Component {
  constructor(...args) {
    super(...args)
    this.state = null
    this.handleChange = handleFieldChange.bind(this, this)
  }
  render() {
    if (!this.state) {
      const { error, inProgress } = this.props
      if (!inProgress && error && (error.message || (error.errors && error.errors.length))) {
        const msg = error.message ||
          (error.status === 403 ? 'You do not have permission to view this profile.' :
           error.status === 404 ? 'This profile could not be found.' :
           'Failed to load profile.')
        return (
          <div id="content">
            <div className={`alert alert-danger ${styles.loadError}`} role="alert">
              <strong>Error {error.status ? `(${error.status})` : ''}:</strong> {msg}
            </div>
          </div>
        )
      }
      return (
        <div id="content" className={styles.loaderWrapper}>
          <span><i className="fa fa-spinner fa-spin" /> Loading...</span>
        </div>
      )
    }
    const {
      router,
      retailerId,
      retailer,
      imageLogo,
      imageRep,
      imageMasthead,
      images,
      isAdminUser,
      validCustomUrl,
      checkingCustomUrl,
      inProgress,
      error,
      deleteRetailer,
      deleteRetailerRepImage,
      deleteRetailerMastheadImage,
      checkRetailerCustomUrl,
      resetCheckRetailerCustomUrl,
      handleImageSelect,
      handleImageRemove,
      handleImageCaptionChange,
      renderError
    } = this.props
    if (!retailer) {
      return null
    }
    let submitButtonText
    let headingText
    if (inProgress) {
      submitButtonText = (
        <span>
          <i className="fa fa-circle-o-notch fa-spin" /> Processing...
        </span>
      )
    } else if (retailerId) {
      submitButtonText = 'Update'
      headingText = 'Edit Profile'
    } else {
      submitButtonText = 'Submit'
      headingText = 'Add Profile'
    }
    let account = null
    if (isAdminUser) {
      account = (
        <Well>
          <header>Account</header>
          <Account
            data={this.state}
            error={error}
            onChangeFactory={this.handleChange}
            disabled={inProgress}
            showUsername={!retailerId}
          />
        </Well>
      )
    }
    const isBasicRetailer = !isAdminUser && !isStandardRetailer(retailer)
    const canDelete = retailerId && isAdminUser && !this.state.isDeleted
    const publicLink = retailer.attributes.publicLink
    const retailerLink = publicLink
      ? `${SERVER}/${publicLink}`
      : `${SERVER}/store/${encodeURIComponent(retailerId)}`
    return (
      <div id="content">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
        <header className={styles.profileForm}>
          <h2>{headingText}</h2>
          <a
            target="_blank"
            href={retailerLink}
            className="btn btn-primary pull-right"
          >
            Live Profile
          </a>
        </header>
        <form className={`smart-form ${styles.form}`} noValidate>
          <FormErrorMessage
            error={error}
            errorListClassName={styles.errorList}
            onRef={node => {
              this.errorNode = node
            }}
          />
          {isBasicRetailer ? null : account}

          {/*
          <Well>
            <header>Subscription</header>
            <Subscription data={this.state} error={error} onChangeFactory={this.handleChange} />
          </Well>
          */}

          <Well className={styles.viewCountWell}>
            <header>Your Views</header>
            <section>
              {this.state.weeklyViewCount > 0
                ? <p>
                    Last week you had{' '}
                    <strong>{this.state.weeklyViewCount}</strong> total views on
                    the Gemsby marketplace!
                  </p>
                : <p>
                    You have not had any views in the past week on the Gemsby
                    marketplace.
                  </p>}
            </section>
          </Well>

          {isBasicRetailer
            ? null
            : <Well>
                <header>Customize Your Profile Link</header>
                <p className={styles.sectionDescription}>
                  Direct anyone to view your seller profile at this unique link.
                </p>
                <ProfileUrl
                  data={this.state}
                  error={error}
                  onChangeFactory={this.handleChange}
                  disabled={inProgress || checkingCustomUrl}
                  validCustomUrl={validCustomUrl}
                  checkingCustomUrl={checkingCustomUrl}
                  onCheckButtonClick={checkRetailerCustomUrl}
                  onReset={resetCheckRetailerCustomUrl}
                />
              </Well>}

          <Well>
            <header>Contact Information</header>
            <p className={styles.sectionDescription}>
              Your email will be how Gemsby consumer messages get to you when
              sent about a specific diamond you&rsquo;ve uploaded. Your email is
              hidden on your public profile, but visible once you are contacted
              through the Gemsby form. A phone number will also help consumers
              get in contact with you faster, and it displays on your profile.
            </p>
            <ContactInfo
              data={this.state}
              isBasicRetailer={isBasicRetailer}
              error={error}
              onChangeFactory={this.handleChange}
              disabled={inProgress}
            />

            <header>Profile Information</header>
            <StoreInfo
              data={this.state}
              isBasicRetailer={isBasicRetailer}
              isAdminUser={isAdminUser}
              error={error}
              onChangeFactory={this.handleChange}
              onGeoSuggestSelect={this.handleGeoSuggestSelect}
              disabled={inProgress}
            />

            {isBasicRetailer
              ? null
              : <div>
                  <header>Sales Representative</header>
                  <p className={styles.sectionDescription}>
                    Filling out a sales representative (this may be you!) gives
                    a more personal feel to your profile. It is best if the
                    represenative matches the phone and email used in your
                    contact information.
                  </p>
                  <StoreRep
                    data={this.state}
                    imageRep={imageRep}
                    onChangeFactory={this.handleChange}
                    onFileSelect={this.handleChange('repImage')}
                    disabled={inProgress}
                    onDeleteRepImage={retailer ? () => deleteRetailerRepImage(retailer) : null}
                  />

                  <header>Your Services</header>
                  <p className={styles.sectionDescription}>
                    Select as many services as you offer.
                  </p>
                  <StoreServices
                    data={this.state}
                    onChangeFactory={this.handleChange}
                    disabled={inProgress}
                  />

                  <header>Tax, Shipping and Returns</header>
                  <StorePolicies
                    data={this.state}
                    onChangeFactory={this.handleChange}
                    disabled={inProgress}
                  />

                  <header>Your Hours</header>
                  <p className={styles.sectionDescription}>
                    Suitable if you have a physical store; otherwise, leave all
                    days as 'Closed'.
                  </p>
                  <StoreHours
                    data={this.state}
                    onChangeFactory={this.handleChange}
                    disabled={inProgress}
                  />

                  <header>Profile Links (Website, Social)</header>
                  <StoreLinks
                    data={this.state}
                    onChangeFactory={this.handleChange}
                    disabled={inProgress}
                  />

                  <header>Profile Gallery</header>
                  <p className={styles.sectionDescription}>
                    A gallery is ideal for showing promotional offers, store
                    photos, your best diamond rings, custom jewelry designs or
                    anything else that will appeal to consumers.
                  </p>
                  <StoreGallery
                    images={images}
                    onSelectFactory={handleImageSelect}
                    onRemoveFactory={handleImageRemove.bind(
                      null,
                      this.props.retailer
                    )}
                    onCaptionChangeFactory={handleImageCaptionChange}
                    disabled={inProgress}
                  />

                  {/*
                  <header>Store Logo</header>
                  <p className={styles.sectionDescription}>
                    Store logo will be displayed on the profile.
                  </p>
                  */}

                  <header>Profile Masthead / Top Banner</header>
                  <p className={styles.sectionDescription}>
                    Customize your profile with a masthead image that displays
                    across the top (large screens). Recommended image
                    dimensions: 2500px wide by 500px high, or 5:1 size ratio.
                  </p>
                  <StoreMasthead
                    imageMasthead={imageMasthead}
                    disabled={inProgress}
                    onFileSelect={this.handleChange('mastheadImage')}
                    onDeleteMastheadImage={retailer ? () => deleteRetailerMastheadImage(retailer) : null}
                  />
                </div>}

            <footer>
              <div className={styles.noteWide}>
                A successful "Save" will redirect<br />
                this form to the retailer screen.
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={this.handleSubmit}
                disabled={inProgress}
              >
                {submitButtonText}
              </button>
              <button
                type="button"
                className="btn btn-default"
                onClick={event => {
                  event.preventDefault()
                  router.goBack()
                }}
                disabled={inProgress}
              >
                Cancel
              </button>
              {canDelete &&
                <button
                  type="button"
                  className="btn btn-danger pull-left"
                  onClick={this.handleDeleteRetailer}
                  disabled={inProgress}
                >
                  Delete Account
                </button>}
            </footer>
          </Well>
        </form>
      </div>
    )
  }
  componentDidMount() {
    this.props.getRetailer(this.props.retailerId)
  }
  componentDidUpdate(prevProps) {
    const { retailer, error, inProgress } = this.props
    // Surface load errors (403, 404, etc.) as toasts
    if (!inProgress && error && (error.message || (error.errors && error.errors.length))) {
      const prevError = prevProps.error
      const isNewError = !prevError || prevError.message !== error.message
      if (isNewError && !this._errorToastShown) {
        this._errorToastShown = true
        const msg = error.message ||
          (error.status === 403 ? 'You do not have permission to perform this action.' :
           error.status === 404 ? 'The requested resource was not found.' :
           'An error occurred.')
        toast.error(msg)
      }
    } else {
      this._errorToastShown = false
    }
    if (!retailer || this.state) {
      return
    }
    const state = _.clone(retailer.attributes)
    unmarshalStoreHours(state)
    state.isAvailable = state.statusCode === statusCodes.AVAILABLE.value
    state.isPrivate = state.statusCode === statusCodes.PRIVATE.value
    state.isDeleted = state.statusCode === statusCodes.DELETED.value
    this.setState(state)
  }
  handleGeoSuggestSelect = event => {
    this.setState({ geo: event.target.value })
  }
  handleSubmit = event => {
    event.preventDefault()
    const {
      retailerId,
      retailer,
      images,
      isAdminUser,
      saveRetailer,
      pendingDeletes,
      clearPendingDeletes
    } = this.props
    saveRetailer(retailer, this.state, images, pendingDeletes).then(
      () => {
        clearPendingDeletes()
        // A retailer editing their own profile gets profile wording; for admins
        // the list we return to names the record (retailer vs customer).
        const savedKey = !isAdminUser
          ? 'profile-updated'
          : retailerId ? 'updated' : 'created'
        this.exit(savedKey)
      },
      () => {
        if (this.errorNode) {
          this.errorNode.scrollIntoView({ behavior: 'smooth' })
        }
      }
    )
  }
  handleDeleteRetailer = event => {
    event.preventDefault()
    const { retailer, deleteRetailer } = this.props
    deleteRetailer(retailer).then(
      () => {
        // Flagged on the url like the save messages: this form has no
        // ToastContainer, the list we redirect to does.
        this.exit('deleted')
      },
      error => {
        const msg =
          (error && error.response && error.response.status === 403)
            ? 'You do not have permission to delete this account.'
            : (error && error.response && error.response.status === 404)
            ? 'This account could not be found.'
            : (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'Failed to delete retailer. Please try again.'
        toast.error(msg)
      }
    )
  }
  exit = savedKey => {
    const { router, location } = this.props
    const backUrl = location.query.backUrl || '/inventory'
    // The success message is shown on the list we redirect to (that is where
    // the ToastContainer lives), so flag it on the URL.
    router.push(savedKey ? withSavedFlag(backUrl, savedKey) : backUrl)
  }
}

function mapStateToProps({ retailer, login }, { params = {} }) {
  let selectedRetailer = retailer.get('selectedRetailer')
  let imageLogo
  let imageRep
  let imageMasthead
  const currentUser = login.get('currentUser')
  const isAdminUser = login.get('isAdminUser')
  let retailerId = params.createdDay && params.retailerId
    ? `${params.createdDay}/${params.retailerId}`
    : (params.retailerId || null)
  if (!retailerId && !isAdminUser) {
    retailerId = currentUser.id
  }
  if (selectedRetailer && (!retailerId || selectedRetailer.id === retailerId)) {
    imageLogo = selectedRetailer.getRelated('imageLogo')
    imageRep = selectedRetailer.getRelated('imageRep')
    // Fallback: API returns storeRepImg as a plain attribute (no relationship)
    if (!imageRep) {
      const storeRepImg = selectedRetailer.get('storeRepImg') || selectedRetailer.get('storeRepImgUrl') || selectedRetailer.get('storeRepImageUrl')
      if (storeRepImg) {
        imageRep = { get: () => storeRepImg }
      }
    }
    imageMasthead = selectedRetailer.getRelated('imageMastHead')
    // Fallback: API returns masthead as a plain URL attribute (no relationship)
    if (!imageMasthead) {
      const mastheadUrl = selectedRetailer.get('profileMastHead')
      if (mastheadUrl) {
        imageMasthead = { get: () => mastheadUrl }
      }
    }
    selectedRetailer = selectedRetailer.toJSON()
  } else {
    selectedRetailer = null
  }
  return {
    retailerId,
    retailer: selectedRetailer,
    imageLogo,
    imageRep,
    imageMasthead,
    inProgress: retailer.get('inProgress'),
    checkingCustomUrl: retailer.get('checkingCustomUrl'),
    validCustomUrl: retailer.get('validCustomUrl'),
    error: retailer.get('error') || {},
    isAdminUser
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getRetailer(retailerId) {
      if (retailerId) {
        dispatch(getRetailer(retailerId))
      } else {
        dispatch(createRetailer())
      }
    },
    saveRetailer(retailer, data, images, pendingDeletes) {
      marshalStoreHours(data)
      const appFee = parseFloat(data.appFee)
      data.appFee = isNaN(appFee) ? data.appFee : appFee
      retailer.attributes = _.omit(
        data,
        'geo',
        'images',
        'repImage',
        'logoImage',
        'mastheadImage',
        'isAvailable',
        'isDeleted',
        'isPrivate'
      )
      if (retailer.attributes.statusCode !== statusCodes.DELETED.value) {
        retailer.attributes.statusCode = data.isPrivate
          ? statusCodes.PRIVATE.value
          : statusCodes.AVAILABLE.value
      }
      Object.assign(retailer.attributes, data.geo, {
        email: data.email && data.email.toLowerCase()
      })
      images = images.filter(({ file }) => file)
      dispatch(
        showFullscreenLoader('Please wait while we are saving the data...')
      )
      const deleteStep = pendingDeletes && pendingDeletes.length
        ? dispatch(deleteRetailerImages(retailer, pendingDeletes))
        : Promise.resolve()
      return deleteStep
        .then(() => dispatch(
          saveRetailer(retailer, {
            galleryImages: images,
            repImage: data.repImage,
            logoImage: data.logoImage,
            mastheadImage: data.mastheadImage
          })
        ))
        .finally(() => {
          dispatch(hideFullscreenLoader())
        })
    },
    deleteRetailer(retailer) {
      return dispatch(deleteRetailer(retailer))
    },
    deleteRetailerRepImage(retailer) {
      return dispatch(deleteRetailerRepImageAction(retailer))
    },
    deleteRetailerMastheadImage(retailer) {
      return dispatch(deleteRetailerMastheadImageAction(retailer))
        .then(() => {
          dispatch(getRetailer(retailer.id))
        })
        .catch(error => {
          const status = error && error.response && error.response.status
          const msg = status === 404
            ? 'Banner image not found. It may have already been removed.'
            : status === 500
            ? 'Server error while removing banner image. Please try again.'
            : status === 401
            ? 'You are not authorised to perform this action.'
            : 'Failed to remove banner image. Please try again.'
          toast.error(msg)
        })
    },
    checkRetailerCustomUrl(customUrl) {
      return dispatch(checkRetailerCustomUrl(customUrl))
    },
    resetCheckRetailerCustomUrl() {
      return dispatch(resetCheckRetailerCustomUrl())
    }
  }
}

function entitySelector({ retailer }) {
  return retailer.get('selectedRetailer')
}

export default compose(
  withRouter,
  withGallery(entitySelector, deleteRetailerImage),
  connect(mapStateToProps, mapDispatchToProps)
)(RetailerForm)
